import request from '@/utils/request2'

// api地址
const api = {
  login: 'biz/userLogin',
  loginByCode: 'biz/loginByCode',
  fetchBizUser: 'biz/getBizUser'
}

// 登录
export const login = (param) => {
  return request.post(api.login, param, { skipAuth: true, load: true })
}

// 登录通过code
export const loginByCode = (param) => {
  return request.post(api.loginByCode, param, { skipAuth: true, load: true, isPrompt: true })
}

export const fetchBizUser = () => {
  return request.get(api.fetchBizUser, {}, { skipAuth: true, load: true, isPrompt: true })
}
